export const setPublicPath = (value: string): void => {
	__webpack_public_path__ = value;
};
